import { IBoard } from '../flux/boards/BoardStore'

const STORAGE_KEY = 'boards'

/**
 * Determines if there is any data stored for the application
 * @returns {boolean} true if there is else false
 */
function hasData() {
    const data = window.localStorage.getItem(STORAGE_KEY)
    return data === null ? false : data.length > 3
}

/**
 * Saves board structure to local storage
 * @param { [key: number]: IBoard } boards Boards to save
 */
function save(boards: { [key: number]: IBoard }) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(boards))
}

/**
 * Loads the stored Kanban boards from local storage
 * @returns { [key: number]: IBoard } Boards or {} if null
 */
function load(): { [key: number]: IBoard } {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    return stored === null ? {} : JSON.parse(stored)
}

export { load, save, hasData }
